/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Wizard application components
import FormField from "layouts/applications/wizard/components/FormField";
import { blueGrey } from "@mui/material/colors";
// import Approved from "assets/results/approved.png";
// import Rejected from "assets/results/rejected.png";
// import Review from "assets/results/review.png";

function Result(props) {
  const num = Math.floor(Math.random() * 100)
  // const num = 99
  
  return (
    <MDBox>
      <MDBox width="80%" textAlign="center" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="h5" fontWeight="regular">
            Automated Review Results
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          Automated Review 
        </MDTypography>
        <Divider sx={{ margin: 2 }} />
        <Grid container spacing={3} justifyContent>
          {(num < 30) && (props.handleResult("approved") || true) && 
            <>
             <Grid item xs={12} md={12}>
                <img style={{width: "100px", height: "100px"}} src="/results/approved.png" />
              </Grid>
              <Grid item xs={12} md={12}>
                <MDTypography variant="body2" color="text">
                  Robin has been approved.
                </MDTypography>
                  Please submit final application.
              </Grid>
              </>
          }
          {(num > 30 && num < 50) &&  (props.handleResult("rejected") || true) && 
            <>
              <Grid item xs={12} md={12}>
                <img style={{width: "100px", height: "100px"}} src="/results/rejected.png" />
              </Grid>
              <Grid item xs={12} md={12}>
                <MDTypography variant="body2" color="text">
                  Robin's has been rejected by the automated review due to the following reasons:
                </MDTypography>
                  - Investments were made by non-qualified investor.
              </Grid>
              <Grid item xs={12} md={12}>
                <MDTypography variant="body2" color="text">
                  Please submit automated review.
                </MDTypography>
              </Grid>
            </>
          }
          {num > 50 &&  (props.handleResult("review") || true) &&
            <>
            <Grid item xs={12} md={12}>
              <img style={{width: "100px", height: "100px"}} src="/results/review.png" />
            </Grid>
            <Grid item xs={12} md={12}>
              Robin's application has been flagged for manual review
            </Grid>
            <Grid item xs={12} md={12}>
              <MDTypography variant="body2" color="text">
                Proceed to manual review.
              </MDTypography>
            </Grid>
            </>
          }        
        </Grid>    
      </MDBox>
    </MDBox>
  );
}

export default Result;
